<template>
  <footer class="app-footer">
    <div class="d-flex flex-wrap justify-content-between">
      <div class="flex-wrap text-center">
        <span>© {{ currentYear }}&nbsp;APNIC</span>
        <span class="ml-3">ABN&nbsp;42&nbsp;081&nbsp;528&nbsp;010</span>
      </div>
      <ul class="d-flex flex-wrap justify-content-center">
        <li v-for="item of footerAsideLinks" :key="item.label_en_us">
          <a :href="item.link">
            {{ item.label_en_us }}
          </a>
        </li>
      </ul>
      <ul class="d-flex flex-wrap justify-content-end">
        <li class="pr-3">Connect with us</li>
        <li v-for="item of footerSocialLinks" :key="item.label_en_us">
          <a :href="item.link" :class="item.iconClass">
            <span class="sr-only">{{ item.label_en_us }}</span>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["themeDataList"]),

    footerAsideLinks() {
      return this.themeDataList.footerAsideLinks || [];
    },

    footerSocialLinks() {
      return this.themeDataList.footerSocialLinks || [];
    },

    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
</style>
